import React from 'react';
import LegalPageLayout from '../../components/common/LegalPageLayout';

const CompliancePage: React.FC = () => (
  <LegalPageLayout
    title="Compliance"
    updated="June 2026"
    intro="Compliance is the foundation of Debtornator, not an add-on. The platform enforces federal collection rules as fail-closed controls — contact that would violate a rule is blocked before it is ever sent. The summaries below describe how Debtornator supports compliance with the FDCPA and TCPA. They are informational and are not legal advice; consult counsel for your specific obligations."
    sections={[
      {
        id: 'fdcpa',
        heading: 'FDCPA Compliance',
        body:
          'The Fair Debt Collection Practices Act (15 U.S.C. § 1692 et seq.) governs how third-party collectors may contact consumers. Debtornator enforces FDCPA controls including: honoring cease-and-desist requests (15 U.S.C. § 1692c(c)) by blocking all channels of contact; restricting calls to the consumer’s lawful calling window; the required “mini-Miranda” disclosure on communications; per-channel opt-out enforcement; and a complete, immutable audit trail of every consumer interaction.',
      },
      {
        id: 'tcpa',
        heading: 'TCPA Compliance',
        body:
          'The Telephone Consumer Protection Act governs calls and text messages. Debtornator enforces TCPA controls including: internal and registry Do-Not-Call suppression for calls and SMS; time-of-day calling-window restrictions; consent revocation enforcement; and per-channel opt-out enforcement. Outbound contact that would violate these rules is blocked at the point of send.',
      },
      {
        heading: 'Audit & Accountability',
        body:
          'Every compliance decision — every block, every disclosure, every consumer contact — is written to an immutable audit log. This gives compliance officers a defensible, tamper-evident record and supports examinations and disputes.',
      },
    ]}
  />
);

export default CompliancePage;
